<template>
  <div>
    <div v-for="option in activity.options">
      <div class="form-group" v-if="!(parentOptions[option.id]) && !(parentOptions[option.id] === null)">
        <label class="control-label">
          {{ option.name }}
        </label>
        <select
          class="form-control"
          name="optionValuesSelected[]"
          :id="option.name"
          :value="variantOptionValues[option.id]"
          @change="onOptionChange(option.id, $event.target.value)"
        >
          <option value="">---</option>
          <option
            v-for="optionValue in option.values"
            :value="optionValue.id"
          >{{ optionValue.code }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      required: true
    },
    modelValue: {
      required: true
    },
    parentOptions: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      variantOptionValues : {},
    }
  },
  methods: {
    findVariant : function(optionValuesSelected) {
      // console.log('findVariant for ', optionValuesSelected)
      const selectedValues = Object.values(optionValuesSelected)
        .filter((optionValueSelected) => optionValueSelected !== null && optionValueSelected !== undefined && optionValueSelected !== '')
        .map((optionValueSelected) => parseInt(optionValueSelected));

      const variant = this.activity.variants.find((variant) => {
        if (! Array.isArray(variant.option_values)) {
          return false;
        }
        if (variant.option_values.length !== selectedValues.length) {
          return false;
        }
        return variant.option_values.every((optionValue) => selectedValues.includes(optionValue.id));
      });
      // console.log('variant found', variant)
      this.$emit('update:modelValue', variant ?? null)
    },
    setOptionsValues : function(variant) {
      // console.log('setOptionsValues', variant);
      const variantOptionValues = this.activity.options.reduce((acc, option) => {
        // console.log('option', option)
        if (!variant || ! Array.isArray(variant.option_values) || !this.parentOptions) {
          acc[option.id] = null
        }
        if (this.parentOptions[option.id]) {
          acc[option.id] = this.parentOptions[option.id];
        }
        // console.log('Option Values', option.values.find(value => variant.option_values.map(v => v.id).includes(value.id)))
        if (variant && Array.isArray(variant.option_values)) {
          const optionValue = option.values.find(value => variant.option_values.map(v => v.id).includes(value.id));
          if (optionValue) {
            acc[option.id] = optionValue.id;
          }
        }
        return acc;
      }, {});
      // console.log('variantOptionValues ---> ', variantOptionValues);
      this.variantOptionValues = variantOptionValues;

      this.$emit('change', this.variantOptionValues)
      this.findVariant(this.variantOptionValues);
    },
    onOptionChange : function (optionId, optionValueId) {
      // console.log('onOptionChange', optionId, optionValueId)
      this.variantOptionValues[optionId] = optionValueId;
      this.handleChange()
    },
    handleChange : function (){
      this.$emit('change', this.variantOptionValues)
      this.findVariant(this.variantOptionValues);
    }
  },
  watch: {
    modelValue: function(variant) {
      this.setOptionsValues(variant)
    },
    variantOptionValues: function(variantOptionValues) {
      // console.log('variantOptionValues change', variantOptionValues);
      this.handleChange()
    },
    parentOptions: function(parentOptions) {
      const optionIds = new Set(this.activity.options.map(option => String(option.id)));
      Object.keys(parentOptions)
        .filter(key => optionIds.has(key))
        .forEach(key => {
          this.variantOptionValues[key] = parentOptions[key];
        });
      this.handleChange()
    }
  },
  mounted() {
    this.setOptionsValues(this.modelValue)
  }
}
</script>

<style scoped>

</style>